import React from 'react';
import './master.css';
import { useDispatch, useSelector } from "react-redux";
import { setScheduleAction } from "../../redux/actions";

const Master = ({ data }) => {
    const dispatch = useDispatch();
    const schedule = useSelector(state => state.schedule);

    return (
        <div className={ `master schedule__item ${ schedule.selected_master === data.id ? 'schedule__item--active' : '' } ${ data.active ? '' : 'schedule__item--inactive' }` }
             onClick={ () => {
                 let selected_master_copy = schedule.selected_master;

                 if (selected_master_copy === data.id) {
                     selected_master_copy = 0;
                 }
                 else {
                     selected_master_copy = data.id;
                 }

                 dispatch(setScheduleAction({
                     ...schedule,
                     selected_master: selected_master_copy
                 }));
             } }
        >
            <div className="master__name"
            >{ data.name }</div>
        </div>
    );
};

export default Master;